import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { publicGuard } from '@core/guards/public.guard';
import { trocaSenhaObrigatoriaGuard } from '@core/guards/troca-senha-obrigatoria.guard';
import { exigeEmailGuard, exigeResetTokenGuard } from '@core/guards/recuperacao-fluxo.guard';
import { LayoutComponent } from '@core/layout/layout.component';
import { AcessoNegadoComponent } from '@modules/acesso-negado/acesso-negado.component';
import { NotFoundComponent } from '@modules/not-found/not-found.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  {
    path: 'login',
    loadChildren: () => import('./modules/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },

  {
    path: 'esqueci-senha',
    canActivate: [publicGuard],
    loadComponent: () =>
      import('@modules/auth/containers/esqueci-senha/esqueci-senha.component').then((m) => m.EsqueciSenhaComponent),
  },

  {
    path: 'verificar-codigo',
    canActivate: [publicGuard, exigeEmailGuard],
    loadComponent: () =>
      import('@modules/auth/containers/verificar-codigo/verificar-codigo.component').then(
        (m) => m.VerificarCodigoComponent,
      ),
  },

  {
    path: 'redefinir-senha',
    canActivate: [publicGuard, exigeResetTokenGuard],
    loadComponent: () =>
      import('@modules/auth/containers/redefinir-senha/redefinir-senha.component').then(
        (m) => m.RedefinirSenhaComponent,
      ),
  },

  {
    path: 'trocar-senha-obrigatoria',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        '@modules/auth/containers/trocar-senha-obrigatoria/trocar-senha-obrigatoria.component'
      ).then((m) => m.TrocarSenhaObrigatoriaComponent),
  },

  {
    // Link do convite por e-mail (#825). Sem publicGuard: quem está logado e abre o link vê o convite.
    path: 'convite/:token',
    loadComponent: () =>
      import('@modules/auth/containers/convite/convite.component').then((m) => m.ConviteComponent),
  },

  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard, trocaSenhaObrigatoriaGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () => import('@modules/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
      },
      {
        path: 'setores',
        loadChildren: () => import('./modules/setores/setores.routes').then((m) => m.SETORES_ROUTES),
      },
      {
        path: 'pacs',
        loadChildren: () => import('./modules/pacs/pacs.routes').then((m) => m.PACS_ROUTES),
      },
      {
        path: 'papeis-assinatura',
        loadChildren: () =>
          import('./modules/papeis-assinatura/papeis-assinatura.routes').then((m) => m.PAPEIS_ASSINATURA_ROUTES),
      },
      {
        path: 'planilhas',
        loadChildren: () =>
          import('@modules/controle-planilhas/controle-planilhas.routes').then((m) => m.CONTROLES_ROUTES),
      },
      {
        path: 'preenchimentos',
        loadChildren: () =>
          import('@modules/preenchimentos/preenchimentos.routes').then((m) => m.PREENCHIMENTOS_ROUTES),
      },
      {
        path: 'relatorios',
        loadChildren: () => import('@modules/relatorios/relatorios.routes').then((m) => m.RELATORIOS_ROUTES),
      },
      {
        path: 'fiscalizacao',
        loadChildren: () => import('@modules/fiscalizacao/fiscalizacao.routes').then((m) => m.FISCALIZACAO_ROUTES),
      },
      {
        // Folhas que aguardam a assinatura do usuário logado.
        path: 'assinaturas',
        loadChildren: () => import('@modules/assinaturas/assinaturas.routes').then((m) => m.ASSINATURAS_ROUTES),
      },
      {
        path: 'usuarios',
        loadChildren: () => import('./modules/usuarios/usuarios.routes').then((m) => m.USUARIOS_ROUTES),
      },
      {
        path: 'meu-perfil',
        loadChildren: () => import('./modules/perfil/perfil.routes').then((m) => m.PERFIL_ROUTES),
      },
      {
        path: 'notificacoes',
        loadChildren: () =>
          import('./modules/notificacoes/notificacoes.routes').then((m) => m.NOTIFICACOES_ROUTES),
      },
      {
        path: 'modelos-nc',
        loadChildren: () => import('./modules/modelos-nc/modelos-nc.routes').then((m) => m.MODELOS_NC_ROUTES),
      },
      {
        path: 'grupos-usuarios',
        loadChildren: () =>
          import('./modules/grupos-usuarios/grupos-usuarios.routes').then((m) => m.GRUPOS_USUARIOS_ROUTES),
      },
      {
        path: 'central-notificacoes',
        loadChildren: () =>
          import('./modules/central-notificacoes/central-notificacoes.routes').then(
            (m) => m.CENTRAL_NOTIFICACOES_ROUTES,
          ),
      },
      {
        path: 'regras',
        loadChildren: () => import('./modules/regras/regras.routes').then((m) => m.REGRAS_ROUTES),
      },
      {
        path: 'funcoes',
        loadChildren: () => import('./modules/funcoes/funcoes.routes').then((m) => m.FUNCOES_ROUTES),
      },
      {
        path: 'empresa',
        loadChildren: () => import('./modules/empresa/empresa.routes').then((m) => m.EMPRESA_ROUTES),
      },
    ],
  },

  // Página de acesso negado 401/403
  { path: 'acesso-negado', loadComponent: () => AcessoNegadoComponent },

  // Página de erro 404
  { path: 'not-found', loadComponent: () => NotFoundComponent },

  // Rota wildcard (para capturar rotas inexistentes)
  { path: '**', redirectTo: 'not-found' },
];
